import React from 'react';
import { Card, Notification } from "rbx";
import AppService from '../../../services/app';
import Controls from '../../components/Controls/Controls';
import { unMask } from '../../../commons/masks';
import useForm from '../../components/useForm';

const types = [
  { value: 1, description: 'CARRO' }, 
  { value: 2, description: 'ÔNIBUS / CAMINHÃO' }
]

const AppRegisterVehicleForm = ({ setMessage, goToMenu }) => {
  const app = JSON.parse(sessionStorage.getItem('app'));

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm( {licensePlate: '', type: ''} );

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStatus('');
    setStateButton("loading");
    try {
      const data = {
        userId: app._id,
        type: parseInt(values.type),
        licensePlate: unMask(values.licensePlate)
      }
      const response = await AppService.registerVehicle(data);
      await AppService.findByCpf(app.cpf_cnpj);
      await AppService.vehiclesParked(app.cpf_cnpj, true);
      setMessage(['success', response.data.message]);
      goToMenu();
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setStateButton('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>Registrar um veículo</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Controls.LicensePlateField 
            label="Placa do Veículo"
            name="licensePlate"
            placeholder='ABC-1234'
            value={values.licensePlate}
            onChange={handleInputChange}
            focus={true}
            required
          />
          <Controls.SelectField
            label="Tipo do Veículo"
            name="type"
            value={values.type}
            onChange={handleInputChange}
            options={types}
            required
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={goToMenu} 
            buttonState={stateButton} 
            buttonName='Registrar'
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default AppRegisterVehicleForm;
